import React from 'react';

/**
 * A conversation's state, as a WORD and the fact behind it.
 *
 * IT DRAWS A DESCRIPTOR AND DECIDES NOTHING. `CustomerServiceDeskService.
 * deskState` is the single place that works out what a conversation is to the
 * desk — resolved, taken, drafted, waiting, unjudgeable — and this renders
 * what it returns. The queue row and the thread header both use it, so they
 * cannot drift into disagreeing about who is on a conversation, which is the
 * whole reason the holder exists.
 *
 * `detail` IS NEVER DECORATION. On `Taken` it is who has it, on a resolution
 * it is who closed it, and on `unknown` it is why the archive cannot judge —
 * a "we could not tell" with no cause attached is indistinguishable from this
 * screen being broken. The queue hides it only because a 250px row cannot
 * carry a sentence, and the thread it opens always shows it.
 *
 * Amber (`warn`) is reserved for "a human is needed" — `Needs a reply` and
 * `Draft ready` — which is the same rule the AI screens' status dots encode,
 * with the same tone vocabulary.
 */
function StateLabel({ descriptor, showDetail = true }) {
  if (!descriptor) return null;

  return (
    <span className="cs-state" data-testid={`cs-state-${descriptor.value}`}>
      <span className={`cs-state__word cs-state__word--${descriptor.tone}`}>
        {descriptor.label}
      </span>
      {showDetail && !!descriptor.detail && (
        <span className="cs-state__reason">{descriptor.detail}</span>
      )}
    </span>
  );
}

export default StateLabel;
